module.exports = __webpack_public_path__ + "37c081126d66ab64fa04f7192113cfa8.jpg";